export default function playWhenInView(videoNodes, threshold = 0.75) {
  var options = {
    root: null,
    rootMargin: '0px',
    threshold: threshold
  };

  var ob = new IntersectionObserver((entries) => {
    var entry = entries[0];
    if (entry.intersectionRatio > threshold) {
      entry.target.play();
    } else {
      entry.target.pause();
    }
  }, options);

  videoNodes.forEach((video) => {
    ob.observe(video);
    // also attach click handler to play as fallback
    video.addEventListener('click', function(event) {
      this.paused && this.play();
    });
  });

}
